import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ICadastroCentroCusto } from 'src/app/pages/centro-de-custos/models/centrocusto';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';

@Component({
  selector: 'app-tab-centro-custo',
  templateUrl: './tab-centro-custo.component.html',
  styleUrls: ['./tab-centro-custo.component.scss']
})
export class TabCentroCustoComponent {
  ERoleAdminString = ERoleAdminString;
  @Input() dadosPaginacaoCentroDeCusto = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };
  @Input() centros: ICadastroCentroCusto[] = [];
  @Input() companyId?: string;

  @Output() mudouPagina = new EventEmitter();
  @Output() mudouTamanhoPagina = new EventEmitter();
  @Output() recarregarListagem = new EventEmitter();

  constructor(private readonly router: Router) { }

  public abrirEmNovaAba(colaboradorId: string): void {
    const url = this.router.serializeUrl(this.router.createUrlTree([`/dash/centro-custos/editar/${colaboradorId}`]));

    window.open(url, '_blank');
  }
}
